export default __webpack_public_path__ + "static/media/17.62802df9.jpg";